import {API_URL} from "../../config/Config";
import axios from "axios";
import {API_TOKEN, logoutUser, setUser} from "./../actions/user";

export async function CheckUserLoginFromApi(store) {
    try {
        let apiToken = await localStorage.getItem(API_TOKEN);
        if (apiToken === null || apiToken ===""){
            store.dispatch(logoutUser());
        }else {
            let response = await axios.get(`${API_URL}user?api_token=${apiToken}`);
            if( response.status === 200){
                store.dispatch(setUser(response.data.data));
            }else{
                store.dispatch(logoutUser());
            }
        }
    } catch(error) {
        console.log(error);
    }
}


// WEBPACK FOOTER //
// ./src/redux/utils/authUtils.js